import {
  isProduction,
  isStage
} from "@src-rf/modules/shared/helpers/check-environment";
import { useEffect } from "react";
import ENVIRONMENT_VAR from "../../../model/const/env/env.const";
import { C_PATH_ROUTES } from "../../../model/const/path.const";
import useUserIs from "../../../hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import {
  IconBrandBlogger,
  IconBuildings,
  IconCloudNetwork,
  IconComponents,
  IconSettings
} from "@tabler/icons-react";
import { IconUsersGroup, IconKey, IconBooks } from "@tabler/icons-react";
import { IconDeviceMobile } from "@tabler/icons-react";
import { IconBuildingCommunity, IconReceiptRefund } from "@tabler/icons-react";
import { IconFileText } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export interface I_MenuItemSideBar {
  label: string;
  route: string;
  icon: React.ReactNode;
  redirect: boolean;
  show: boolean;
  onClick?: () => void;
}

const useMenuItemsSideBar = () => {
  const navigate = useNavigate();
  const { MAXCORE_DOMAIN_V1 } = ENVIRONMENT_VAR;
  const { userIs } = useUserIs();
  const { ADMIN, BROKER, BROKER_MANAGER, SUPER_ADMIN } = ERolesCode;

  const handleNavigation = (route: string, redirect: boolean) => {
    if (redirect) {
      window.location.href = route;
    } else {
      navigate(route);
    }
  };

  const MENU_ITEMS: I_MenuItemSideBar[] = [
    {
      label: "Propiedades",
      route: C_PATH_ROUTES.REALESTATE.LIST,
      icon: <IconBuildings />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation(C_PATH_ROUTES.REALESTATE.LIST, false)
    },

    {
      label: "Usuarios",
      route: "/user",
      icon: <IconUsersGroup />,
      show: userIs(SUPER_ADMIN, ADMIN, BROKER, BROKER_MANAGER),
      redirect: false,
      onClick: () => handleNavigation("/user", false)
    },
    {
      label: "Agencias",
      route: "/agencies",
      icon: <IconBuildingCommunity />,
      show: userIs(SUPER_ADMIN),
      redirect: false,
      onClick: () => handleNavigation("/agencies", false)
    },
    {
      label: "Propietarios",
      route: "/owners",
      icon: <IconKey />,
      redirect: false,
      show: userIs(SUPER_ADMIN),
      onClick: () => handleNavigation("/owners", false)
    },
    {
      label: "Comisiones",
      route: `${MAXCORE_DOMAIN_V1}/commissions`,
      icon: <IconBooks />,
      redirect: true,
      show: true,
      onClick: () => handleNavigation(`${MAXCORE_DOMAIN_V1}/commissions`, true)
    },

    {
      label: "Reportes",
      route: "/reports",
      icon: <IconFileText />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation("/reports", false)
    },
    {
      label: "Herramientas",
      route: "/tools",
      icon: <IconSettings />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation("/tools", false)
    },
    {
      label: "Ref. Hipotecario",
      route: `/mortgage-reference`,
      icon: <IconReceiptRefund />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation("/mortgage-reference", false)
    },
    {
      label: "Contactos",
      route: `${MAXCORE_DOMAIN_V1}/contacts`,
      icon: <IconUsersGroup />,
      redirect: true,
      show: true,
      onClick: () => handleNavigation(`${MAXCORE_DOMAIN_V1}/contacts`, true)
    },
    {
      label: "App móvil",
      route: "/app-movil",
      icon: <IconDeviceMobile />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation("/app-movil", false)
    },
    {
      label: "Intranet",
      route: "https://intranet.remaxrd.com/",
      icon: <IconCloudNetwork />,
      redirect: true,
      show: true,
      onClick: () => handleNavigation("https://intranet.remaxrd.com/", true)
    },
    {
      label: "CRM",
      route: "https://crm.remaxrd.com/web",
      icon: <IconComponents />,
      redirect: false,
      show: true,
      onClick: () => handleNavigation("https://crm.remaxrd.com/web", true)
    },

    // blog remax
    {
      label: "Blog",
      route: "https://blog.remaxrd.com/",
      icon: <IconBrandBlogger />,
      redirect: true,
      show: true,
      onClick: () => handleNavigation("https://blog.remaxrd.com/", true)
    }
  ];

  useEffect(() => {}, []);

  return MENU_ITEMS.filter(item => item.show);
};

export default useMenuItemsSideBar;
